import React, { Component } from "react";
import "../TotalCss.css";
import { Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { SiteTitle } from "../SiteTitle";
import { FetchDataUserTable } from "../FetchDataUserTable";
import { api_url } from "../globalFunction/global_string";
export class UserTypeSet extends Component {
  static displayName = UserTypeSet.name;

  constructor(props) {
    super(props);
    this.state = {
      showModal: false, //初始化 modal 關閉
      isDataUnitNameFetched: false,
      isDataUnitUrlFetched: false,
      isDataFetched: true, // 初始化尚未取得資料
      fetchedData: {
        current_user_type: localStorage.getItem('login_user_id'),
        apiUrl: api_url + '/api/Async/GetListData',
      }, // 初始化資料容器
    }
  }

  render() {
    return (
      <div>
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>使用者權限設定</h1>
          <div id="site_manage" className="row col-12 mb-5">
          </div>
          {this.state.isDataFetched && <FetchDataUserTable
            fetchedData={this.state.fetchedData}
          />}
        </div>
      </div>
    )
  }
}